import { Box, BoxProps } from '@mui/material';

type BackgroundImageProps = {
  src: string;
} & BoxProps;

export const BackgroundImage: React.FC<BackgroundImageProps> = ({ src, ...props }) => (
  <Box
    sx={(theme) => ({
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundColor: '#e3e3e3',
      height: 0,
      paddingBottom: '50%',
      width: '100%',
      backgroundImage: `url(${src})`,

      [theme.breakpoints.up('md')]: {
        pb: 'calc(100% / 6)',
        width: 'calc(100% / 6)',
      },
    })}
    {...props}
  />
);
